import {useTranslation} from "react-i18next";
import CustomDaySelector from "../../../../../../../components/CustomDaySelector";
import {IconClockTable} from "../../../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../../../components/CustomChip";
import {colors} from "../../../../../../../enums/colors";
/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 21 de 01 de 2026
 */

const GeofenceCardBody = ({geofence, backgroundColor, dayArray}) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={`${backgroundColor} row`}>
                <div className={"col-12 p-0 border-bottom-shades-300 mb-3"}>
                    <p className={"font-color-shades-500 fs-12px ibl-font-w-600"}> {t('active_schedule')} </p>
                </div>

                <div className='col-12 p-0'>
                    <CustomDaySelector
                        dayArray={dayArray}
                        setDayArray={() => {}}
                        containerClasses={'w-auto'}
                        readonlyBorderColor={colors.shades500}
                        readonlyCheckedColor={colors.shades500}
                        readonlyBackgroundColor={colors.shades100}
                        readonlyTextColor={colors.shades500}
                        readonly={true}
                    />
                </div>
                <div className={"col-12 p-0 my-3"}>
                    <div className={'d-flex align-items-center'}>
                        <IconClockTable className='icon-color-shades-500' />
                        <p className={'font-color-shades-500 fs-14px ibl-font-w-500 ml-2'}>
                            {geofence.opening}
                            &nbsp;{t('to').toLowerCase()}&nbsp;
                            {geofence.closing}
                        </p>
                    </div>
                </div>
                <div className={"col-12 p-0 border-bottom-shades-300 mb-2"}>
                    <p className={"font-color-shades-500 fs-12px ibl-font-w-600"}>
                        {t('devices')}
                    </p>
                </div>
                <div className='d-flex flex-wrap gap-2'>
                    {geofence?.devices?.length > 0 &&
                        geofence?.devices.map((device) => (
                            <CustomChip
                                key={device.id}
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={t(device?.label)}
                                variant='compact'
                            />))
                    }
                </div>
            </div>
        </>
    );
};
export default GeofenceCardBody;
